import React from 'react';
import ListItem from '../../../../../reusableComponents/baseListItems/baseList13';
import Button from '../../../../../reusableComponents/buttons/button11';

const TOCList = ({ curriculumData = [] }) => {
  // Check if curriculum data is available
  if (!curriculumData || curriculumData.length === 0) {
    // Display a message if no curriculum data is available
    return (
      <div className="w-full p-4 border border-gray-200 rounded-lg">
        <div className="text-center py-6">
          <p className="text-gray-600 mb-2">No curriculum data is available for this course.</p>
          <p className="text-gray-500 text-sm">Please contact an administrator for assistance.</p>
        </div>
      </div>
    );
  }

  // Use curriculum data from props since we've verified it exists
  const lessons = curriculumData;

  // Handle lesson start
  const handleStartLesson = (lesson, index) => {
    console.log(`Starting lesson: ${lesson.title || lesson.name}`);
    console.log(`Lesson index: ${index}`);
    // You can add navigation to lesson content here if needed
  };

  return (
    <div className="w-full flex flex-col gap-3">
      {lessons.map((lesson, index) => (
        <ListItem
          key={index}
          label={lesson.label || `Module ${index + 1}`}
          title={lesson.title || lesson.name || `Lesson ${index + 1}`}
          showDescription={lesson.showDescription || false}
          description={lesson.description || ''}
          showImage={lesson.showImage || false}
          width="w-full"
        >
          <Button
            text="Start lesson"
            size="Compact"
            state="Default"
            type="Secondary"
            variant="Default"
            textClass="text-[14px]"
            onClick={() => handleStartLesson(lesson, index)}
            className=""
          />
        </ListItem>
      ))}
    </div>
  );
};

export default TOCList;